import { Create, Default, Detail, List } from "./views";


const Module = {
    name: "permissions",
    defaultRoutePath: "/people/permission",
    menuItemScope: "people",
    menuItemName: "permissions",

    routes: [
        {
            path: "/people/permission",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        {
            path: "create",
            Component: Create,
        },
    ],
   
}

export default Module;
